export default __webpack_public_path__ + "static/media/appointments_4.a02c6442.jpg";